import { Box, HStack, Icon, SimpleGrid, Text } from '@chakra-ui/react';
import { FiHome, FiCheck, FiBriefcase, FiRotateCcw } from 'react-icons/fi'

interface Props {
  doorsKnocked: number
  contactsReached: number
  businessesVisited: number
  pendingCallbacks: number
}

export function TodayNumbers({ doorsKnocked, contactsReached, businessesVisited, pendingCallbacks }: Props) {
  return (
    <Box bg="surface" p={5} borderRadius="lg" border="1px" borderColor="gray.200">
      <Text fontSize="xs" fontWeight="medium" color="gray.500" textTransform="uppercase" mb={3}>
        Today&apos;s Progress
      </Text>
      <SimpleGrid columns={2} gap={3}>
        <Box>
          <HStack gap={1} color="gray.500" mb={1}>
            <Icon boxSize={3} asChild><FiHome /></Icon>
            <Text fontSize="xs">Doors Knocked</Text>
          </HStack>
          <Text fontWeight="bold" fontSize="lg">{doorsKnocked.toLocaleString()}</Text>
        </Box>
        {businessesVisited > 0 && (
          <Box>
            <HStack gap={1} color="gray.500" mb={1}>
              <Icon boxSize={3} asChild><FiBriefcase /></Icon>
              <Text fontSize="xs">Businesses Visited</Text>
            </HStack>
            <Text fontWeight="bold" fontSize="lg">{businessesVisited.toLocaleString()}</Text>
          </Box>
        )}
        <Box>
          <HStack gap={1} color="gray.500" mb={1}>
            <Icon boxSize={3} asChild><FiCheck /></Icon>
            <Text fontSize="xs">Contacts Reached</Text>
          </HStack>
          <Text fontWeight="bold" fontSize="lg">{contactsReached.toLocaleString()}</Text>
        </Box>
        {/* Campaign-wide open NoAnswer/Callback backlog (all days) — not a today count, so it can exceed Doors Knocked. */}
        {pendingCallbacks > 0 && (
          <Box>
            <HStack gap={1} color="orange.500" mb={1}>
              <Icon boxSize={3} asChild><FiRotateCcw /></Icon>
              <Text fontSize="xs">Open Callbacks</Text>
              <Text fontSize="2xs" opacity={0.8}>all days</Text>
            </HStack>
            <Text fontWeight="bold" fontSize="lg" color="orange.600">{pendingCallbacks.toLocaleString()}</Text>
          </Box>
        )}
      </SimpleGrid>
    </Box>
  );
}
